var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ErrorType } from "../types/ErrorType";
import { readServerErrors } from "./serverErrorUtils";
/** HTTP status mod-br-publishers answers when the ARES rate limiter has no free slot (DB-876). */
export var TOO_MANY_REQUESTS_STATUS = 429;
/** Error type / code mod-br-publishers puts on a rate-limited request. */
export var TOO_MANY_REQUESTS_ERROR = "TOO_MANY_REQUESTS";
var ARES_DATA_NOT_FOUND_CODE = "NOT_FOUND_ERROR";
/**
 * Whether the failed request was rejected because the backend is out of ARES request slots.
 *
 * @param error the error thrown by the ky client
 * @returns true for HTTP 429 or a server error of type TOO_MANY_REQUESTS
 */
export var isTooManyRequestsError = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var status;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (typeof error !== "object" || error === null)
                    return [2 /*return*/, false];
                status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
                if (status === TOO_MANY_REQUESTS_STATUS)
                    return [2 /*return*/, true];
                return [4 /*yield*/, readServerErrors(error)];
            case 1: return [2 /*return*/, (_b.sent()).some(function (item) {
                    return item.type === TOO_MANY_REQUESTS_ERROR ||
                        item.code === TOO_MANY_REQUESTS_ERROR;
                })];
        }
    });
}); };
/**
 * The message shown under the company number when "Načíst z ARES" fails: ARES is overloaded (429),
 * ARES has no data for the company number, or the message the server sent.
 *
 * @param error the error thrown by the ky client
 * @param formatMessage react-intl formatMessage
 * @param companyNumber the company number that was looked up
 * @returns the message, empty when the server sent none
 */
export var resolveAresLookupErrorMessage = function (error, formatMessage, companyNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var firstError;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, isTooManyRequestsError(error)];
            case 1:
                if (_b.sent()) {
                    return [2 /*return*/, formatMessage({ id: "ui-br-publishers.error.aresTooManyRequests" })];
                }
                return [4 /*yield*/, readServerErrors(error)];
            case 2:
                firstError = (_b.sent())[0];
                if ((firstError === null || firstError === void 0 ? void 0 : firstError.type) === ErrorType.INTERNAL &&
                    (firstError === null || firstError === void 0 ? void 0 : firstError.code) === ARES_DATA_NOT_FOUND_CODE) {
                    return [2 /*return*/, formatMessage({ id: "ui-br-publishers.error.aresDataNotFound" }, { ico: companyNumber !== null && companyNumber !== void 0 ? companyNumber : "" })];
                }
                return [2 /*return*/, (_a = firstError === null || firstError === void 0 ? void 0 : firstError.message) !== null && _a !== void 0 ? _a : ""];
        }
    });
}); };
